<template>
  <rt-section :title="title" icon="rt-base-device">
    <el-upload
      slot="btn"
      ref="upload"
      :on-success="uploadSuccess"
      :on-error="uploadError"
      :on-change="fileChanged"
      :action="fileUploadUrl"
      :headers="config"
      :data="fileData"
      :name="fileName"
      :file-list="fileList"
      :show-file-list="false"
      :auto-upload="true"
      multiple
    >
      <rt-button-group>
        <rt-button icon-name="rt-base-plus_bold"></rt-button>
      </rt-button-group>
    </el-upload>

    <div v-if="fileList.length <= 0" class="empty-file">
      <p>{{ $tx('暂时没有附件哦', 'xpc.attachment.novalue') }}</p>
    </div>
  </rt-section>
</template>
<script>
export default {
  name: 'RtAttachment',
  props: {
    // 模块名称
    controllerName: {
      type: String,
      default: ''
    },
    ObjectId: {
      type: String,
      default: ''
    },
    // 附件Module
    moduleType: {
      type: String
    }
  },
  data() {
    return {
      fileUploadUrl: 'https://jsonplaceholder.typicode.com/posts/',
      fileName: '',
      config: {
        Authorization: 'Bearer ' + this.$store.state.auth.accessToken
      },
      fileData: {
        ModuleType: this.moduleType,
        FileId: '',
        FileName: this.fileName,
        ObjectId: this.objectId,
        IsOverwrite: '0'
      },
      fileList: []
    };
  },
  computed: {
    title() {
      return this.$tx('附件', 'xpc.attachment.title');
    },
    successmsg() {
      return this.$tx('附件上传成功！', 'xpc.attachment.successmsg');
    }
  },
  methods: {
    addAttachment() {},
    uploadSuccess(response, file, fileList) {
      let success = true;
      this.fileList = fileList;
      fileList.forEach(item => {
        if (item.status !== 'success') {
          success = false;
        }
      });
      if (success) {
        this.$message({
          showClose: true,
          message: this.successmsg,
          type: 'success'
        });
      }
    },
    uploadError(err, file) {},
    // 文件改变触发
    fileChanged(file, fileList) {}
  }
};
</script>



// WEBPACK FOOTER //
// rtAttachment.vue?4c3c0f0e